import { render, staticRenderFns } from "./LanguageTime.vue?vue&type=template&id=64d6a680"
import script from "./LanguageTime.ts?vue&type=script&lang=ts&external"
export * from "./LanguageTime.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports